import wrapBackboneView from 'utils/backbone/wrapBackboneView';

const oldModulesImports = {
  administrationController: () => import('legacy/modules/administration/controller'),
  commonController: () => import('legacy/modules/common/controller'),
  errorPagesController: () => import('legacy/modules/errors/controller'),
  accountsController: () => import('legacy/modules/accounts/controller'),
  closureController: () => import('legacy/modules/closure/controller'),
  useraccountsController: () => import('legacy/modules/useraccounts/controller'),
  projectsController: () => import('legacy/modules/projects/controller'),
  ordersController: () => import('legacy/modules/orders/controller'),
  orderPeriodsController: () => import('legacy/modules/orderperiods/controller'),
  placementsController: () => import('legacy/modules/placements/controller'),
  placementTaggingGroupsController: () => import('legacy/modules/placements/tagging/controller'),
  usersController: () => import('legacy/modules/users/controller'),
  payersController: () => import('legacy/modules/payers/controller'),
  advertisersController: () => import('legacy/modules/advertisers/controller'),
  brandsController: () => import('legacy/modules/brands/controller'),
  additionalServicesController: () => import('legacy/modules/additionalservices/controller'),
  bookingController: () => import('legacy/modules/booking/controller'),
  companiesController: () => import('legacy/modules/companies/controller'),
  contractsController: () => import('legacy/modules/contracts/controller'),
  reportsController: () => import('legacy/modules/reports/controller'),
  markupsController: () => import('legacy/modules/markups/controller'),
  markupsRatesController: () => import('legacy/modules/markups/rates/controller'),
  historyController: () => import('legacy/modules/history/controller'),
  customersController: () => import('legacy/modules/customers/controller'),
  oldConnectionsController: () => import('legacy/modules/connectionsOld/controller'),
  oldConnectionParamsController: () => import('legacy/modules/connectionsOld/params/controller'),
  webAnalyticsController: () => import('legacy/modules/webanalytics/controller'),
  searchController: () => import('legacy/modules/search/controller'),
  currencyController: () => import('legacy/modules/currency/controller'),
  bidmanagerController: () => import('legacy/modules/optimization/bidmanager/controller'),
  toolsController: () => import('legacy/modules/tools/controller'),
  financesController: () => import('legacy/modules/finances/controller'),
  financialReportsController: () => import('legacy/modules/financialreports/controller'),
  generationController: () => import('legacy/modules/tools/generation/controller'),
  syncSourcesController: () => import('legacy/modules/sync/sources/controller'),
  syncGroupsController: () => import('legacy/modules/sync/groups/controller'),
  mediaplansController: () => import('legacy/modules/rore/mediaplans/controller'),

  // rore routes
  roreCoefficientsController: () => import('modules/rore/coefficients/controller'),
  roreDisclaimersController: () => import('modules/rore/disclaimers/controller'),
  roreFormatsController: () => import('modules/rore/formats/controller'),
  roreFormatTypesController: () => import('modules/rore/formats/types/controller'),
  roreMediaplansController: () => import('modules/rore/mediaplans/controller'),
  rorePagesController: () => import('modules/rore/pages/controller'),
  rorePlacesController: () => import('modules/rore/places/controller'),
  rorePlaceContextsController: () => import('modules/rore/places/contexts/controller'),
  rorePriceTypesController: () => import('modules/rore/pricetypes/controller'),
  roreRotationTypesController: () => import('modules/rore/rotationtypes/controller'),
  roreSitesController: () => import('modules/rore/sites/controller'),
  roreSitePlatformsController: () => import('modules/rore/sites/platforms/controller'),
  roreSiteSalesHousesController: () => import('modules/rore/sites/saleshouses/controller'),
  roreSiteTypesController: () => import('modules/rore/sites/types/controller'),
  roreStrategiesController: () => import('modules/rore/strategies/controller'),
  roreSuppliersController: () => import('modules/rore/suppliers/controller'),
  roreTechCostsController: () => import('modules/rore/techcosts/controller')
};


function c (controllerName, methodName) {
  return {
    controllerGetter: oldModulesImports[controllerName],
    methodName
  };
}


function wrapLegacyRoute (controllerName, methodName) {
  const callBack = c(controllerName, methodName);
  return async () => wrapBackboneView(callBack.controllerGetter, callBack.methodName);
}

export default wrapLegacyRoute;
